import React from "react";
import { useEffect, useMemo, useState } from "react";
import dayjs from "dayjs";
import { Link } from "react-router-dom";
import { useUser } from "../../../hooks/use-user";
import { errorToast } from "../../../utils/toast";
import axios from "../../../axios";
import { FaArrowRightLong, FaWhatsapp } from "react-icons/fa6";
import Correct from "../../../Images/Vector.png";
import bgImage from "../../../Images/Section (2).png";
import Info from "../../../Images/ph_info-duotone.png";
import Table from "../../../componant/Table/Table";
import Cell from "../../../componant/Table/cell";
import UserNameLink from "../userControl/components/UserNameLink";
import {
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuDivider,
  InputGroup,
  InputLeftElement,
  Input,
  Button,
  InputRightAddon,
  useDisclosure,
  Drawer,
  Select, 
  DrawerBody,
  DrawerFooter,
  DrawerHeader,
  DrawerOverlay,
  DrawerContent,
  DrawerCloseButton,
} from "@chakra-ui/react";

import { MdEdit, MdDelete } from "react-icons/md";
import { HiStatusOnline } from "react-icons/hi";
import { GrOverview, GrWhatsapp } from "react-icons/gr";
import PaginationNav from "../../../componant/Pagination/Pagination";
function ContestUsers() {
  const [newID, setNewID] = useState(null);

  const { isOpen, onOpen, onClose } = useDisclosure();
  const {
    isOpen: isOpen2,
    onOpen: onOpen2,
    onClose: onClose2,
  } = useDisclosure();
  const cancelRef = React.useRef();
  const btnRef = React.useRef();
  const [data, setData] = useState({
    todayUsers: [],
    weeklyUsers: [],
    monthlyUsers: [],
  });

  const [filterType, setFilterType] = useState("today"); // today | weekly | monthly
  const [searchText, setSearchText] = useState("");
  const [sortBy, setSortBy] = useState("");
  const [dataType, setDataType] = useState("userContestStates"); // "course" | "contest"
  const [contests, setContests] = useState([]);
const [allUsers, setAllUsers] = useState([]);
const [allUsersCount, setAllUsersCount] = useState(0);
const [selectedContest, setSelectedContest] = useState("");
const [selectedUser, setSelectedUser] = useState(null);
const {
  isOpen: isContestOpen,
  onOpen: onContestOpen,
  onClose: onContestClose,
} = useDisclosure();

  const [page, setPage] = useState(1);
const pageSize = 50;


useEffect(() => {
  async function fetchData() {
    try {
      if (filterType === "all") {
        const response = await axios.get("getAllContestUsers");

       const users = (response.data.result || []).map((item) => ({
  ...item.user,
  contest: item.contest,
  contestAmount: item.contestAmount,
  createdOn: item.createdOn,
}));

setAllUsers(users);
setAllUsersCount(response.data.totalUsers);
        return;
      }

      const api =
        dataType === "course" ? "userCourseStats" : "userContestStates";

      const response = await axios.get(`${api}?type=${filterType}`);

      if (response?.data) {
        setData(response.data.result);
      }
    } catch (err) {
      errorToast("Failed to fetch data");
    }
  }

  fetchData();
}, [filterType, dataType]);

useEffect(() => {
  axios
    .get("getAllContestForUser")
    .then((response) => {
      const result = response?.data?.result;
      const contestList = Array.isArray(result)
        ? result
        : result?.contests || [];

      setContests(contestList);
    })
    .catch(() => {
      errorToast("Failed to fetch contests");
    });
}, []);

  const finalData = useMemo(() => {
    let baseData = [];

if (filterType === "all") {
  baseData = allUsers;
} else if (filterType === "today") {
  baseData = data?.todayUsers || [];
} else if (filterType === "weekly") {
  baseData = data?.weeklyUsers || [];
} else if (filterType === "monthly") {
  baseData = data?.monthlyUsers || [];
}

    let users = [...baseData];

    if (searchText) {
      users = users.filter(
        (user) =>
          user.name?.toLowerCase().includes(searchText.toLowerCase()) ||
          user.email?.toLowerCase().includes(searchText.toLowerCase()) ||
          user.mobile?.toString().includes(searchText),
      );
    }

    if (sortBy === "latest") {
      users.sort((a, b) => new Date(b.createdOn) - new Date(a.createdOn));
    } else if (sortBy === "oldest") {
      users.sort((a, b) => new Date(a.createdOn) - new Date(b.createdOn));
    } else if (sortBy === "name") {
      users.sort((a, b) =>
        (a.name || "").localeCompare(b.name || "", undefined, {
          sensitivity: "base",
        }),
      );
    } else if (sortBy === "contestBalanceHigh") {
      users.sort(
        (a, b) =>
          Number(b?.unifiedWallet?.contestBalance || 0) -
          Number(a?.unifiedWallet?.contestBalance || 0),
      );
    } else if (sortBy === "contestBalanceLow") {
      users.sort(
        (a, b) =>
          Number(a?.unifiedWallet?.contestBalance || 0) -
          Number(b?.unifiedWallet?.contestBalance || 0),
      );
    }

    return users;
  }, [data, filterType, searchText, sortBy]);
  
  // pagination
  const totalPages = Math.ceil(finalData.length / pageSize); 

  const paginatedData = useMemo(() => {
  const start = (page - 1) * pageSize;
  const end = start + pageSize;

  return finalData.slice(start, end);
}, [finalData, page]);

useEffect(() => {
  setPage(1);
}, [filterType, searchText, sortBy]);

  // total earning card
  const contestEntryCoinMap = useMemo(() => {
    return new Map(
      contests.map((contest) => [
        String(contest._id),
        Number(contest.entryCoin) || 0,
      ]),
    );
  }, [contests]);
  // total user count
const userCount = useMemo(() => {
  if (filterType === "all") return allUsersCount || 0;
  if (filterType === "today") return data?.todayCount || 0;
  if (filterType === "weekly") return data?.weeklyCount || 0;
  if (filterType === "monthly") return data?.monthlyCount || 0;
  return 0;
}, [filterType, data, allUsers]);

const totalEarning = useMemo(() => {
  return finalData.reduce((total, user) => {
    return total + (user?.contestAmount || 0);
  }, 0);
}, [finalData]);

 const sendSingleContestMessage = async () => {
  if (!selectedContest) {
    return errorToast("Please select contest");
  }

  try {
    const res = await axios.post(
      "/sendContestWhatsAppMessage",
      {
        contestId: selectedContest,
        userId: [selectedUser._id], // only one user
      }
    );

    alert(res.data.message);

    onContestClose();

    setSelectedContest("");
    setSelectedUser(null);

  } catch (err) {
    errorToast(
      err?.response?.data?.message || "Failed"
    );
  }
};
// What's App Message
const sendLiveContestMessage = async () => {
  try {
    const userIds = (data?.weeklyUsers || []).map(user => user._id);

     console.log("Weekly Users:", data?.weeklyUsers?.length);
    console.log("UserIds:", userIds.length);
    console.log(userIds);
    
    if (!userIds.length) {
      return errorToast("No weekly users found");
    }

    const res = await axios.post("/sendContestMessageForWeeklyUsers", {
      userIds,
      contestId: selectedContest,
    });

    alert(res.data.message);
  } catch (err) {
    errorToast(
      err?.response?.data?.message || "Failed to send WhatsApp message"
    );
  }
};

  const columns = React.useMemo(
    () => [
      {
  Header: "Sr No.",
  accessor: "srNo",
  Cell: ({ row: { index } }) => (
    <Cell text={(page - 1) * pageSize + index + 1} />
  ),
},
      {
        Header: "User",
        accessor: "name",
        Cell: ({ value, row: { original } }) => (
          <>
            <UserNameLink
              userId={original?._id}
              name={value}
              planName={original?.planName}
              email={original?.email}
            />
            <div className="flex items-center justify-center gap-2 text-13 mt-2">
              <div className="flex gap-2 ">
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-green-600 rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-green">
                    {original?.rightCount}
                  </h1>
                </div>
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-redC rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-red">
                    {original?.wrongCount}
                  </h1>
                </div>
                <div className="flex justify-center items-center gap-2">
                  <div className="w-10 bg-yellow-400 rounded-full p-1 h-1 "></div>
                  <h1 className="text-md font-bold text-yellow-500">
                    {original?.skipCount}
                  </h1>
                </div>
              </div>
              {/* <div className="py-1 shadow-md px-2 bg-bgWhite text-black border-1 border-coolGray rounded-lg flex flex-col-2 gap-2 items-center justify-items-center">
                <Image
                  alt="Rate"
                  src={rateIcon}
                  width={20}
                  height={20}
                  layout="fixed"
                />

                <div className="text-center">
                  {original?.planName === "Silver"
                    ? 3000
                    : original?.planName === "Silver Plus"
                    ? 2000
                    : original?.planName === "Gold"
                    ? 1500
                    : original?.planName === "Platinum"
                    ? 1000
                    : 3000}
                  /1$
                </div>
              </div> */}
            </div>
          </>
        ),
      },

      {
        Header: "Mobile No.",
        accessor: "mobile",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={original.mobile} />
          </>
        ),
      },
    
      {
        Header: "Created On",
        accessor: "createdOn",
        Cell: ({ value, row: { original } }) => (
          <Cell text={dayjs(value).format("D MMM, YYYY h:mm A")} />
        ),
      },
{
  Header: "Total Contest Joined",
  accessor: "joinedContests",
  Cell: ({ row: { original } }) => (
    <Cell
      text={
        Array.isArray(original?.joinedContests)
          ? original.joinedContests.length
          : 0
      }
    />
  ),
},
  {
        Header: "Contest Balance",
        accessor: "unifiedWallet.contestBalance",
        Cell: ({ value, row: { original } }) => (
          <>
            <Cell text={original.unifiedWallet.contestBalance} />
          </>
        ),
      },
      {
        Header: "Action",
        accessor: "",
        Cell: ({ value, row: { original } }) => {
          return (
            <>
              <Menu>
                <MenuButton
                  as={Button}
                  className="bg-purple "
                  colorScheme="bgBlue"
                  onClick={() => setNewID(original._id)}
                >
                  Actions
                </MenuButton>
                <MenuList>
                  <Link to={`/dash/view-user/${original._id}`}>
                    <MenuItem>
                      {" "}
                      <GrOverview className="mr-4" /> View Details
                    </MenuItem>
                  </Link>
                  <Link to={`/dash/edit-user/${original._id}`}>
                    <MenuItem>
                      {" "}
                      <MdEdit className="mr-4" /> Edit
                    </MenuItem>
                  </Link>

                  <MenuItem onClick={onOpen2}>
                    {" "}
                    <HiStatusOnline className="mr-4" /> Hold User
                  </MenuItem>
                   <MenuItem
  onClick={() => {
    setSelectedUser(original);
    onContestOpen();
  }}
>
  <FaWhatsapp className="mr-4"/>
  Send Contest Message
</MenuItem>

                  {/* <MenuItem onClick={onOpen}>
                    {" "}
                    <MdDelete className="mr-4" />
                    Delete
                  </MenuItem> */}
                  <Link to={`/dash/view-question/${original._id}`}>
                    <MenuItem>
                      <GrOverview className="mr-4" /> Change Plan
                    </MenuItem>
                  </Link>
                </MenuList>
              </Menu>
            </>
          );
        },
      },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data],
  );

  return (
    <div
      className="bg-bgWhite px-3 py-4 sm:px-4 lg:py-8"
      // style={{
      //   backgroundImage: `url('${bgImage}')`,
      //   backgroundSize: "cover",
      //   backgroundRepeat: "no-repeat",
      //   backgroundPosition: "center",
      // }}
    >
      <section className="md:p-1">
        <div className="py-4">
          <h2 className="text-xl font-bold mb-4 text-purple text-oswald">
            {dataType === "course" ? "Course Users" : "Contest Users"}
          </h2>
          {filterType === "weekly" && (
          <div className="flex w-full flex-col gap-3 mb-5 md:flex-row md:items-center md:w-auto">
  <Select
    placeholder="Select Contest"
    value={selectedContest}
    onChange={(e) => setSelectedContest(e.target.value)}
    maxW={{ base: "100%", md: "280px" }}
    minW={{ md: "220px" }}
  >
    {contests.map((contest) => (
      <option key={contest._id} value={contest._id}>
        {contest.contestName}
      </option>
    ))}
  </Select>

  <Button
    colorScheme="green"
    onClick={sendLiveContestMessage}
    width={{ base: "100%", md: "auto" }}
    whiteSpace="nowrap"
  >
    Send Contest Live Message
  </Button>
</div>
          )}
          <div className="flex flex-col gap-4 xl:flex-row xl:items-center xl:justify-between">
            <div className="flex w-full flex-wrap gap-2 sm:w-auto sm:flex-nowrap">
                 <Button
  onClick={() => setFilterType("all")}
  colorScheme={filterType === "all" ? "blue" : "gray"}
  className="flex-1 sm:flex-none"
  size="sm"
>
  All
</Button>
              <Button
                onClick={() => setFilterType("today")}
                colorScheme={filterType === "today" ? "blue" : "gray"}
                className="flex-1 sm:flex-none"
                size="sm"
              >
                Today
              </Button>

              <Button
                onClick={() => setFilterType("weekly")}
                colorScheme={filterType === "weekly" ? "blue" : "gray"}
                className="flex-1 sm:flex-none"
                size="sm"
              >
                Weekly
              </Button>

              <Button
                onClick={() => setFilterType("monthly")}
                colorScheme={filterType === "monthly" ? "blue" : "gray"}
                className="flex-1 sm:flex-none"
                size="sm"
              >
                Monthly
              </Button>

            </div>
         
      <div className="flex flex-col md:flex-row gap-3 mb-4">
  {/* User Count */}
  <div className="bg-blue-100 text-blue-700 px-4 py-3 rounded-lg shadow text-center min-w-[180px]">
    <h2 className="text-sm font-medium">
      {filterType === "today" && "Today's Users"}
      {filterType === "weekly" && "Weekly Users"}
      {filterType === "monthly" && "Monthly Users"}
    </h2>

    <p className="text-xl font-bold">
      {userCount}
    </p>
  </div>

  {/* Total Earning */}
  <div className="bg-green-100 text-green-700 px-4 py-3 rounded-lg shadow text-center min-w-[180px]">
    <h2 className="text-sm font-medium">
      {filterType === "today" && "Today's contest Entry Credits"}
      {filterType === "weekly" && "Weekly contest Entry Credits"}
      {filterType === "monthly" && "Monthly contest Entry Credits"}
    </h2>

    <p className="text-xl font-bold">
      ₹ {totalEarning.toLocaleString()}
    </p>
 
  </div>
  
</div>
            <div className="w-full xl:max-w-sm">
              <InputGroup borderRadius={5} size="sm">
                <InputLeftElement
                  pointerEvents="none"
                  // children={<Search2Icon color="gray.600" />}
                />
                <Input
                  type="text"
                  placeholder="Search..."
                  border="1px solid #949494"
                  value={searchText}
                  onChange={(e) => setSearchText(e.target.value)}
                />
                <InputRightAddon p={0}>
                  <Button
                    className="bg-purple"
                    colorScheme="#FF782D"
                    size="sm"
                    borderLeftRadius={0}
                    borderRightRadius={3.3}
                    border="1px solid #949494"
                  >
                    Search
                  </Button>
                </InputRightAddon>
              </InputGroup>
            </div>

            <div className="flex w-full flex-wrap items-center gap-2 xl:w-auto">
              {/* 🔥 Toggle Course / Contest */}
              {/* Existing Sort Button */}
              <Menu>
                <MenuButton
                  as={Button}
                  colorScheme="#FF782D"
                  zIndex={20}
                  className="bg-bgBlue"
                >
                  {sortBy ? "Sorted" : "Sort By"}
                </MenuButton>

                <MenuList zIndex={20}>
                  <MenuItem onClick={() => setSortBy("latest")}>
                    Latest First
                  </MenuItem>
                  <MenuItem onClick={() => setSortBy("oldest")}>
                    Oldest First
                  </MenuItem>
                  <MenuItem onClick={() => setSortBy("name")}>
                    Name A–Z
                  </MenuItem>
                  <MenuItem onClick={() => setSortBy("contestBalanceHigh")}>
                    Contest Balance: High to Low
                  </MenuItem>
                  <MenuItem onClick={() => setSortBy("contestBalanceLow")}>
                    Contest Balance: Low to High
                  </MenuItem>
                  <MenuItem onClick={() => setSortBy("")}>
                    Reset Sort
                  </MenuItem>
                </MenuList>
              </Menu>
            </div>
            <Drawer
              isOpen={isOpen2}
              placement="right"
              onClose={onClose2}
              finalFocusRef={btnRef}
            >
              <DrawerOverlay />
              <DrawerContent>
                <DrawerCloseButton />
                <DrawerHeader>Create your account</DrawerHeader>

                <DrawerBody>
                  <Input placeholder="Type here..." />
                </DrawerBody>

                <DrawerFooter>
                  <Button variant="outline" mr={3} onClick={onClose2}>
                    Cancel
                  </Button>
                  <Button colorScheme="blue">Save</Button>
                </DrawerFooter>
              </DrawerContent>
            </Drawer>
          </div>
          <div className="mt-5">
            <div className="hidden md:block">
              <Table data={paginatedData || []} columns={columns} />
   <div className="items-center justify-center">
                    <PaginationNav
  pageIndex={page}
  pageCount={totalPages || 1}
  onPageChange={(newPage) => setPage(newPage)}
/>
            </div>
            </div>
            
   <Drawer
  isOpen={isContestOpen}
  placement="right"
  onClose={onContestClose}
>
  <DrawerOverlay />
  <DrawerContent>
    <DrawerCloseButton />

    <DrawerHeader>
      Send Contest WhatsApp
    </DrawerHeader>

    <DrawerBody>

      <p className="mb-3 font-semibold">
        {selectedUser?.name}
      </p>

      <Select
        placeholder="Select Contest"
        value={selectedContest}
        onChange={(e) => setSelectedContest(e.target.value)}
      >
        {contests.map((contest) => (
          <option key={contest._id} value={contest._id}>
            {contest.contestName}
          </option>
        ))}
      </Select>

    </DrawerBody>

    <DrawerFooter>
      <Button
        mr={3}
        onClick={onContestClose}
      >
        Cancel
      </Button>

      <Button
        colorScheme="green"
        onClick={sendSingleContestMessage}
      >
        Send
      </Button>
    </DrawerFooter>
  </DrawerContent>
</Drawer>

            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 md:hidden">
              {paginatedData.map((user, index) => (
                <article
                  key={user._id}
                  className="min-w-0 rounded-xl border border-gray-200 bg-white p-4 shadow-sm"
                >
                  <div className="flex min-w-0 items-center gap-3">
                    <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-purple text-lg font-bold text-white">
                      {(user?.name || "U").charAt(0).toUpperCase()}
                    </div>
                    <div className="min-w-0">
                      <p className="text-xs font-semibold text-gray-400">#{index + 1}</p>
                      <h3 className="truncate font-bold text-gray-800">
                        {user?.name || "User Deleted"}
                      </h3>
                      <p className="truncate text-sm text-gray-500">{user?.email || "-"}</p>
                    </div>
                  </div>

                  <div className="mt-4 grid grid-cols-2 gap-3 text-sm">
                    <div>
                      <p className="text-xs text-gray-500">Mobile</p>
                      <p className="truncate font-semibold">{user?.mobile || "-"}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">Contest Balance</p>
                      <p className="font-semibold">₹ {Math.ceil(user?.unifiedWallet?.contestBalance || 0)}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">Total Credits</p>
                      <p className="font-semibold">₹ {Math.ceil(user?.unifiedWallet?.balance || 0)}</p>
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">Created On</p>
                      <p className="font-semibold">{dayjs(user?.createdOn).format("D MMM, YYYY")}</p>
                    </div>
                  </div>

                  <div className="mt-4 grid grid-cols-2 gap-2">
                    <Link
                      to={`/dash/view-user/${user._id}`}
                      className="rounded-lg bg-purple px-3 py-2 text-center text-sm font-semibold text-white"
                    >
                      View Details
                    </Link>
                    <Link
                      to={`/dash/edit-user/${user._id}`}
                      className="rounded-lg border border-purple px-3 py-2 text-center text-sm font-semibold text-purple"
                    >
                      Edit User
                    </Link>
                  </div>
                </article>
              ))}
            </div>
            <div className="md:hidden mt-5 flex justify-center">
  <PaginationNav
    pageIndex={page}
    pageCount={totalPages}
    onPageChange={(newPage) => setPage(newPage)}
  />
</div>

            {paginatedData.length === 0 && (
              <div className="rounded-xl bg-white p-8 text-center text-gray-500 md:hidden">
                No contest users found.
              </div>
            )}
          </div>
        </div>
      </section>
    </div>
  );
}

export default ContestUsers;
